//日语
module.exports = {
  index1: "登録",
  index2: "ログイン",
  index3: "詳しくは",
  index3_1: "ノードアクセラレーション",
  ssl: "SSLノードを取得する",
  ssl_copy: '正常に取得されました。使用するアプリケーションに貼り付けてください',
  index4: "索引",
  index5: "私たちに関しては",
  index6: "フォローする",
  index7: "言語",
  index8: "あなたの暗号資産を選択してください",
  index9: "これは最も信頼できる暗号通貨取引所であり、そのセキュリティで知られています。",
  index10: "メンバーはすでに参加しています！",
  index11: "今すぐ無料アカウントに登録してください！",
  index12: "今すぐ登録！",
  index13: "マーケットプレイス",
  index14: "すべての革命にはリーダーが必要です。",
  index15: "最高の取引プラットフォームは、ブロックチェーンの約束の力を習得し、運動の一部になりたい人のために設計されています。 超高速のトランザクション速度、信頼性の高いデジタルウォレット、業界をリードするセキュリティにより、この革新的なテクノロジーをリードする取引所を設立しました。",
  index16: "私たちの利点",
  index17: "安全第一",
  index18: "取引所を選ぶとき、信頼は重要です。 これが、安全が常に私たちの最優先事項であり、これからも重要である理由です。 当社のプラットフォームはゼロから構築されており、複数の保護層があり、資金と取引の安全性を確保するために最も効果的で信頼性の高いテクノロジーを導入しています。",
  index19: "単純なトランザクションを超えた変革",
  index20: "ブロックチェーンは、業界全体および暗号化を超えた画期的なソリューションを提供する可能性があると信じています。 私たちは世界中のチームと協力して、商品、サービス、運用のあらゆる場所での管理方法を変えることができる、新しくクリエイティブなトークンを宣伝しています。",
  index21: "高速で強力なテクノロジー",
  index22: "当社の取引エンジンは、需要の高い状況下でのリアルタイムの注文実行を容易にするために、規模と速度に合わせてカスタマイズされています。 さまざまなAPIを通じて、サードパーティの取引プラットフォームとアルゴリズム取引をサポートしています。",
  index23: "トップデジタル通貨市場",
  index24: "豊富な市場リストで、トレンドを把握し、自信を持って取引してください。",
  index25: "スマートフォン",
  index26: "デジタル資産取引アプリケーションをダウンロードしてください！",
  index27: "スマートフォンで直接一流の暗号通貨交換を取得します。 このアプリケーションをダウンロードして取引する方が簡単、迅速、安全です。",
  index28: "Apple App Store",
  index29: "Google Play Store",
  index30: "ユーザーの声",
  index31: "私たちは何ですか？",
  index32: "私たちはオンラインのデジタル資産取引プラットフォームです。 プラットフォームでは、BTC、LTC、ETH、BCH、GDOGE、XRP、TRX、BNB、その他の暗号資産など、さまざまな暗号資産を購入できます。",
  index33: "ビットコインとは何ですか？",
  index34: "簡単に言えば、ビットコインはデジタル資産です。 この種の資産取引は、クレジットカードや中央銀行の地方分権化を必要とせずに実行できます。 これは、ユーザーが非常にシンプルで効率的な方法でオンライン送金を行えるように設計されています。 ビットコインは2009年に中本聡によって開発されました。この資産は金のようなものですが、デジタルの世界にのみ存在します。 この概念は実際にはかなり異なりますが、デジタルゴールドのように聞こえるかもしれません。",
  index35: "アカウントへの入金方法は？",
  index36: '「アセット-リチャージ」をクリックし、「使用したい支払い方法」を選択します。 例：BTC、ETH、USDT。 購入したい金額を入力してください。 転送用のウォレットアドレスをコピーします。 振込完了後、必ず「譲渡性預金」にご記入ください。 私たちの金融チームがあなたの預金を確認するのを待ってください。 資金は10〜30分以内に残高に表示されます。',
  index37: "お問い合わせ",
  index38: "全著作権所有",
  index39: "知らせ",
  index40: "このウェブサイトの目的は、関連性を示すことだけです",
  index41: "アプリで利用可能な製品とサービスに関する情報。 アプリで利用可能な製品とサービスに関する情報。 そのような製品やサービスへのアクセスを提供する意図はありません。 あなたはアプリでそのような製品やサービスにアクセスすることができます。",
  index42: "すべてのメディアとインタビューのリクエストについてはお問い合わせください",
  index43: "あなたの宣伝を探しています",
  index44: "パートナーシップの機会に関心がある",
  index45: "一般的な問題",
  index46: "私達に電子メールを送り",

  about1: "私たちは世界をリードするデジタル通貨資産取引プラットフォームであり、ユーザーに安全でプロフェッショナルで便利なデジタル通貨取引サービスを提供することをお約束します。 ユーザーの視点から、私たちはブロックチェーン分野の深い理解に依存して、グローバルユーザーのために高品質の通貨を選択し、ブロックチェーンテクノロジーのトレンドをリードしています。",
  about2: "コアチームには、上級技術エンジニア、グローバルブロックチェーンリサーチの専門家、国際的な運用チーム、世界クラスのリスク管理の専門家、その他の業界トップの才能が集まっています。 世界をリードする暗号化技術、自社開発のクラスターメモリマッチングシステムを採用し、複数の通貨を集約します。 複数の言語をサポートし、グローバルユーザーに、より安全で、より安定した、より便利なデジタル資産取引を提供することをお約束します。",
  about3: "当社のデジタル資産取引サービスプラットフォームは、デジタル資産取引サービスに重点を置いており、専門的な取引機能、スマートトランザクションとスマートマッチング、便利なトランザクション、資金委託、および簡単なアカウント管理を提供します。 同時に、業界の大小のデジタル通貨取引所と連絡を取り、協力し、情報を伝達および交換し、世界をカバーするデジタル資産の共通の概念に到達します。",
  about4: "便利でスムーズなユーザーエクスペリエンスを実現するために、ユーザーの使用習慣を慎重に作成し、最初にエクスペリエンスの原則に基づいてプロセス設計全体を実行します。 システムは、7〜24の中断のないトランザクションサービスシステムレベルのセキュリティ保護を提供します。 デジタル通貨業界を深く育て、ユーザーにトップレベルのシステムレベルのセキュリティ保証を提供するために、デジタル通貨業界で多くの研究開発の才能を蓄積してきました。 さまざまな国からのデジタル通貨の導入を継続して、ユーザーにグローバルトランザクションサービス、豊富なデジタル通貨通貨を提供し、通貨市場で高品質の通貨を収集し、包括的な範囲のデジタル通貨を提供します",
  about5: "私たちは常に耳を傾け、気遣い、前向きに考えます。 私たちは、暗号通貨と従来の金融業界の利点を統合することにより、革新を続けることができることを願っています。 優れたプラットフォーム機能と専門的な設計コンセプトを通じて、業界で最も安全で、最も効率的で、公正で透明な取引体験をユーザーに提供します。",
}



// WEBPACK FOOTER //
// ./src/common/lang/jp.js